<template>
    <div class="col-lg-12 col-md-12 col-sm-12" v-if="showPrinterReport === true">
        <button class="no-print btn btn-primary" onclick="window.print();">Print Report</button> <br /><br />
        <div class="row" style="width:1200px;" v-if="TopAddHTML !== ''">
            <br />
            <div style="padding-left:30px" v-html="TopAddHTML" class="col-lg-12 col-md-12 text-center"></div>
        </div>
        <!---thead repeats on each new page-->
        <table class="table textleft" v-if="selectedReport">
            <thead>
                <tr>
                    <td colspan="100">
                        <h2>{{translateText(selectedReport.Description)}}</h2><br />
                        <div class="row" v-if="selectedReport && selectedReport.DefaultReportDateRangeID !== 0 && selectedReport.DefaultReportDateRangeID !== null">
                            <div class="col-lg-12 textleft">
                                <b>{{translateText("Date Range")}}: </b>{{this.translateDate(this.$store.getters.getStartDate)}} - {{translateDate(this.$store.getters.getEndDate)}}
                                <br />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th v-for="(col, index) in reportOnlyColumns" class="PayGo_report_table_header" :key="index">
                        <div class="PayGo_full_width">
                                <div style="float: left;">
                                <div class="PayGo_report_item_padding PayGo_report_word_wrap">
                                    <label class="PayGo_report_column_header PayGo_report_word_wrap">{{translateText(col.Title)}}</label>
                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(row, rowIndex) in filteredRows" >
                    <tr :key="rowIndex" :class="row.subReport != '' ? 'rpt-subrpt-expanded' : ''">
                        <td v-for="(val, index) in row.RowValues" class="rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'" :key="index"
                            :style="Columns[index] !== undefined && Columns[index].DisplayLocation === reportOnlyDisplayLocation ? '' : 'display: none;'">
                            <div class="PayGo_full_width">
                                <div class="float: left;">
                                    <div class="PayGo_report_item_padding PayGo_report_word_wrap">
                                        <span class="PayGo_report_word_wrap" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'text' && Columns[index].ColumnType !== 'popuplinkbutton'">{{val}}</span>
                                        <div v-html="val" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'html'"></div>
                                        <span v-if="Columns[index].ColumnType === 'popuplinkbutton'">{{JSONParse(val).Value}}</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="row.subReport != ''" :key="rowIndex">
                        <td colspan="100" class="rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'">
                            <div v-html="row.subReport"></div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import {store} from "../../store/index";
import vuejsDatepicker from "vue2-datepicker";
import moment from "moment";
//Simple Vue object to keep printer friendly data.  All data is called from the calling parent, so no need 
//to go back to the database, or to the Ajax Model... all of that should be handled by the caller.
export default {
    name: "PrinterReport",
    data() {
        return {
            filteredRows: [],
            Columns: [],
            selectedReport: null,
            errorMsg: '',
            TopAddHTML: '',
            showPrinterReport: false,
            reportOnlyDisplayLocation: this.$ReportDislayLocation.ReportAndCSV
        }
    },
    components: {
        Datepicker: vuejsDatepicker,
        moment
    },
    methods: {
        JSONParse: function(jsonString) {
            try

            {
                return JSON.parse(jsonString);
            }
            catch(error)
            {
                return jsonString;
            }
            
        },
       translateText(pageText) {
            if (pageText === undefined) {
                return ""
            }

            var languages = this.$i18n.messages
            var currentLanguage = this.$i18n.locale
            
            // Check if current language is part of our set up
            if (currentLanguage in languages) {
                // Get all the messages for this language
                var currentLanguageMessages = languages[currentLanguage].message
                if (currentLanguageMessages !== null && (pageText !== "")) {
                    var languageText = currentLanguageMessages[pageText.replace(/ /g, "").toLowerCase()]
                    return languageText !== undefined ? languageText : pageText
                }
            }
            
            return pageText
        },
        translateDate(date) {
            return moment(date).format(this.translateText("dateFormat"));
        }
    },
    mounted () {

        this.filteredRows = this.$store.getters.getFilteredRows;
        this.Columns = this.$store.getters.getColumns;
        this.selectedReport = this.$store.getters.getSelectedReport;
        this.TopAddHTML = this.$store.getters.getTopAddHTML;

        //For the listboxes, I wanted to make it list all the possible selected values.
        for (var index = 0, len = this.selectedReport.ReportCriteria.length; index < len; index++) {
            var value = this.selectedReport.ReportCriteria[index];
            if (value.ControlType === "multi") {
                if (value.Value === "SelectAll") {
                    value.Value = "All";
                }
                else {
                    value.Value = value.ValueList.join(", ");
                }
            }
            else if (value.ControlType === "date") {
                if (!isNaN(value.Value)) {
                    value.Value = moment(value.Value).format(this.translateText("dateFormat"));
                }
                
            }
        }
        this.showPrinterReport = true;
    },
    computed: {
        reportOnlyColumns() {
            return this.Columns.filter(col => col.DisplayLocation === this.reportOnlyDisplayLocation);
        }
    }    
}

</script>
<style>
    .textleft {
        text-align: left;
    }

    .rpt-subrpt-expanded td {
        border-bottom: 0px !important;
    }
</style>